@if (dashboardData) {
  <div class="p-3 pt-2 rounded-4">
    @if (!dashboardData.total && !dashboardData.success && !dashboardData.failed && !dashboardData.refund) {
      <div class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted"></i>
        <p class="text-muted mt-2">No data available for the selected period</p>
      </div>
    }
    <div>
      <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 text-center p-0">
        <button class="btn btn-link text-decoration-none text-white p-3" (click)="setActiveTab('transactions')"
          [ngClass]="isActive('transactions') ? 'border-bottom rounded-0 border-3' : ''">
          <i class="bi bi-database-fill"></i>
          Transactions
        </button>
        <button class="btn btn-link text-decoration-none text-white p-3" (click)="setActiveTab('risk')"
          [ngClass]="isActive('risk') ? 'border-bottom rounded-0 border-3' : ''">
          <i class="bi bi-shield-fill"></i>
          Risk
        </button>
        <button class="btn btn-link text-decoration-none text-white p-3" (click)="setActiveTab('ops')"
          [ngClass]="isActive('ops') ? 'border-bottom rounded-0 border-3' : ''">
          <i class="bi bi-gear-fill"></i>
          OPS
        </button>
      </div>
    </div>
    <div class="container-fluid mb-3 date-filter-wrapper">
      <app-date-filter [fromDate]="selectedFromDate" [toDate]="selectedToDate"
      (dateSelected)="onDateSelected($event)"></app-date-filter>
    </div>
    <div class="container-fluid">
      @if (isActive('transactions')) {
        <div class="row bg-white p-2 pt-0">
          <div class="col-md-3">
            <div class="card card-total rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-primary border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.total}}</div>
                    <!-- <div>{{dashboardData.totalSum | number}}</div> -->
                  </div>
                  <div class="text-center">
                    <i class="bi bi-calculator fs-1 fw-bold mt-n-15px"></i>
                    <div>TOTAL</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-success rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-success border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.success}}</div>
                    <!-- <div>{{dashboardData.successSum | number}}</div> -->
                  </div>
                  <div class="text-center">
                    <i class="bi bi-check fs-1 fw-bold mt-n-15px"></i>
                    <div>SUCCESS</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-failed rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-danger border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.failed}}</div>
                    <!-- <div>{{dashboardData.failedSum | number}}</div> -->
                  </div>
                  <div class="text-center">
                    <i class="bi bi-x fs-1 fw-bold mt-n-15px"></i>
                    <div>FAILED</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-refund rounded p-3 p-xxl-4 mt-4">
              <div class="card-body border-start border-warning border-3 pt-0 pb-0">
                <div class="d-flex justify-content-between">
                  <div class="">
                    <div class="fs-1 fw-bold">{{dashboardData.refund}}</div>
                    <!-- <div>{{dashboardData.refundSum | number}}</div> -->
                  </div>
                  <div class="text-center">
                    <i class="bi bi-arrow-counterclockwise fs-1 fw-bold mt-n-15px"></i>
                    <div>REFUND</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
              <p class="primaryColor fs-5 fw-bold">Country Wise Spending</p>
              <div class="">
                <ngx-charts-bar-vertical [scheme]="colorScheme" [results]="barChartSettings.data"
                  [gradient]="barChartSettings.gradient" [barPadding]="40"
                  [xAxis]="barChartSettings.showXAxis" [yAxis]="barChartSettings.showYAxis"
                  [legend]="barChartSettings.showLegend" [showXAxisLabel]="barChartSettings.showXAxisLabel"
                  [showYAxisLabel]="barChartSettings.showYAxisLabel"
                  [xAxisLabel]="barChartSettings.xAxisLabel" [yAxisLabel]="barChartSettings.yAxisLabel"
                  [tooltipDisabled]="false">
                </ngx-charts-bar-vertical>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
              <p class="primaryColor fs-5 fw-bold">Number of Transactions</p>
              <div class="">
                <ngx-charts-bar-horizontal [scheme]="colorScheme" [results]="transactionsPieChart.data"
                  [gradient]="barChartSettings.gradient"
                  [xAxis]="true" [yAxis]="true" [showXAxisLabel]="true" [showYAxisLabel]="true"
                  [xAxisLabel]="'Count'" [yAxisLabel]="'Country'" [tooltipDisabled]="false">
                </ngx-charts-bar-horizontal>
              </div>
            </div>
          </div>
        </div>
      }
      @if (isActive('risk')) {
        <div class="row bg-light p-2 pt-0 rounded-3">
          <app-risk></app-risk>
        </div>
      }
      @if (isActive('ops')) {
        <div class="row bg-light p-2 pt-0 rounded-3">
          <app-ops></app-ops>
        </div>
      }
    </div>
  </div>
}